<script context="module">
  const FETCH_STATES = {
    idle: 'idle',
    pending: 'pending',
    success: 'success',
    error: 'error',
  };
</script>

<script>
  import Loader from '../Loader.svelte';
  import InfoAlert from '../Alert/InfoAlert.svelte';
  export let noResultMessage = 'No Results';

  export let data = [];
  export let state;
</script>

{#if state === FETCH_STATES.pending}
  <slot name="pending">
    <Loader type="overlay" />
  </slot>
{:else if state === FETCH_STATES.success}
  {#if data.length === 0}
    <div class="d-flex align-items-center justify-content-center w-100 h-100">
      <slot name="empty">
        <p class="font-size-16 ash-color">{noResultMessage}</p>
      </slot>
    </div>
  {:else}
    <slot name="success" />
  {/if}
{:else if state === FETCH_STATES.error}
  <slot name="error">
    <InfoAlert message="Error" />
  </slot>
{/if}
